<template>
  <div class="top">
    <div class="in">
      <el-form :rules="rules" :model="userform">
        <el-form-item label="原密码：" style="font-size:1000" prop="oldpassword">
          <el-input  type="password" v-model="userform.oldpassword" placeholder="请输入原密码"></el-input> 
          </el-form-item  >
        <el-form-item label="新密码：" prop="newpassword">
          <el-input  type="password" v-model="userform.newpassword" placeholder="请输入新密码"></el-input>
          </el-form-item>
        <el-form-item label="确认新密码：" prop="confirmpassword">
          <el-input  type="password" v-model="userform.confirmpassword" placeholder="请确认密码"></el-input>
          </el-form-item>
        <el-button class="btn-submit" @click="update()">确认</el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { updatePsw } from "../../api/userMG";
export default {
  data() {
    return {
      userId: localStorage.getItem("userId"),
      pd: localStorage.getItem("pd"),
      userform: {
        oldpassword: "",
        newpassword: "",
        confirmpassword: "",
      },
        rules: {
          oldpassword: [{required: true, message: '原密码不为空', trigger: 'blur'}],
          newpassword: [{required: true, message: '新密码不为空', trigger: 'blur'}],
          confirmpassword: [{required: true, message: '确认密码不为空', trigger: 'blur'}],
        },
    };
  },
  // 注册组件
  components: {},
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    update() {
      if (this.userform.oldpassword == ""||this.userform.oldpassword==undefined) {
        this.$message.error("请输入原密码");
      }else if(this.userform.oldpassword!=this.pd){
        this.$message.error("原密码输入错误");
      } 
      else if (this.userform.newpassword != this.userform.confirmpassword) {
        this.$message.error("两次密码输入不一致");
      }
      else{
          let params = {
          token: localStorage.getItem("token"),
          id: this.userId,
          password: this.userform.confirmpassword,
        };
        updatePsw(params).then((res) => {
        if (res.errno === 0) {
          // this.$message({
          //   type: "success",
          //   message: res.data,
          // });
          this.$message({
            type:'warning',
            message:'密码已修改，请重新登录'
          })
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else if (res.errno === 401) {
          this.$store.dispatch("LogOut").then(() => {
            location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        } else {
          this.$message.error(res.error);
        }
      });
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.in >>>.el-form-item__label{
  font-weight: 700;
  font-size: 15px;
}
/* .in >>>.el-input__inner{
  height: 32px;
} */

.top{
   padding: 20px;

  height: 100%;
  background-color: #ffffff;
}
  .in>>>.el-input__inner{
  width: 394px;
  height: 32px;
  font-size: 12px;
  color: #999999;
  border: 1px solid #cccccc;
}
.in>>>.el-input__inner:hover{
  border: 1px solid #b0bceb;
  font-size: 12px;
}
.in>>>.el-input__inner:focus{
  border:1px solid #2b52e9;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/views/account/user.vue